import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { CheckFCRequest, CustomerSearchDataPagination, CustomerSearchFilters, IGetUniqueIDParams, LinkCustomerData } from "../../types";


export const searchCustomerByFilters = (queryFilters: any) => {
    return axios.post("/customer/search", queryFilters);
};

export const getCustomerBaseById = (id: any) => {
    return axios.get(`/customer/${id}`);
}

export const searchCustomerByFiltersAsync = async (filters: CustomerSearchDataPagination) => {
    const resp = await axios.post("/customer/search", filters);
    return resp.data;
};

export const getCustomerBaseByIdAsync = async (id: any) => {
    const resp = await axios.get(`/customer/${id}`);
    return resp.data;
}

export const getCustomerBaseByUniqueId = (queryParams: IGetUniqueIDParams) => {
    return axios.get("/customer", {params: queryParams});
}

export const findCustomerBaseByUniqueData = (queryBody: CustomerSearchFilters) => {
    return axios.post("/customer/find-by-unique-data", queryBody)
}

export const findCustomerBaseByUniqueDataAsync = async (queryBody: CustomerSearchFilters) => {
    const resp = await axios.post("/customer/find-by-unique-data", queryBody);
    return resp.data;
}

/*export const getCustomerBaseByUniqueIdAsync = async (taxCode: string | null, drvLicenceNumber: string | null, type: string | null) => {
    const resp = await axios.get("/customer", {params: {taxCode, drvLicenceNumber, type}});
    return resp.data;
}*/

export const editCustomerbaseFields = ({queryKey}: any) => {
    const [_key, {queryFields}] = queryKey;
    return axios.put("/customer", queryFields);
}

export const createCustomerBase = (({queryKey}: any) => {
    const [_key, {queryFields}] = queryKey;
    return axios.post("/customer", queryFields);
})

export const getSapEnumConfiguration = () => {
    return axios.get("/customer/sap-configuration");
}

export const useGetCustomerByIdMetaQueryObserver = (id?: string) => {
    return useQuery({
        queryKey: ['getCustomerBaseById', id],
        enabled: false
    });
}

export const getMobilePrefix = () => {
    return axios.get("/customer/prefix");
}

export const verifyTaxCode = ((request: CheckFCRequest) => {
    return axios.post("/customer/verify/taxcode", request);
})

export const verifyTaxCodeAsync = async (request: CheckFCRequest) => {
    const resp = await axios.post("/customer/verify/taxcode", request);
    return resp;
}

export const getCountries = () => {
    return axios.get("/customer/countries");
}

interface IGetCountriesReturn {
    data?: {
        message?: string,
        code?: string,
        data?: string[]
    }
}

export const useGetCountriesMetaQueryObserver = () => {
    return useQuery<IGetCountriesReturn | null>({
        queryKey: ['getCountries'],
        queryFn: () => { 
            return getCountries();
        },
        enabled: false
    });
}

export const getProvincesByCountry = (country: string) => {
    return axios.get(`/customer/provinces/${country}`);
}

export const getProvinces = () => {
    return axios.get("/customer/provinces");
}

export const getCargosPlaces = (province?: string, issueDate?: string) => {
    return axios.get("customer/cargos/places", {params: {province: province, issueDate: issueDate}});
}

export const linkCustomer = (body: LinkCustomerData) => {
    return axios.post("/customer/link-customer", body);
}

export const unlinkCustomer = (body: LinkCustomerData) => {
    return axios.post("/customer/unlink-customer", body);
}

export const getDossierOriginOption = async (): Promise<string[]> => {
    const response = await axios.get("/customer/dossier-origin");
    return response.data;
}
